import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  TimePicker,
  Input,
  InputNumber,
  Radio,
  Switch,
  Button,
  DatePicker,
  Modal,
  Descriptions,
  List,
  Typography,
  AutoComplete,
  Tag,
  Space,
  Collapse,
  Card,
  Popconfirm,
} from "antd";
import { toRupiah } from "../../../../libs";
import { baseRequest } from "../../../../util/Api";
import _ from "lodash";
import moment from "moment-timezone";
import {
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  ArrowRightOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { deleteTrainingVideo, getTrainingVideo, saveNewTrainingVideo } from "../../../../appRedux/actions/TrainingVideo";
import Meta from "antd/lib/card/Meta";

const { Panel } = Collapse;

export default function NewTrainingForm({
  trainers = [],
  trainersLoading = false,
  trainingOptions = [],
  trainingOptionsLoading = false,
  onSubmit,
  submitLoading = false,
  showDatesField = true,
  update = false,
  training,
}) {
  const [form] = Form.useForm();
  const [formVideo] = Form.useForm();
  const [showAdvancedFields, setShowAdvancedFields] = useState(false);
  const [locations, setLocations] = useState([]);
  const [locationRequired, setLocationRequired] = useState(true);
  const [type, setType] = useState(3);
  const [defaultTrainerId, setDefaultTrainerId] = useState(null)
  const [videos, setVideos] = useState([])
  const [showVideosEndRequired, setShowVideosEndRequired] = useState(false)

  useEffect(async () => {
    const data = await baseRequest("get", "/trainings/locations", null);
    let options = [];
    data.map((value) => {
      options.push({
        value: value,
      });
    });
    setLocations(options);

    if (training) {
      let typeValue = 3;
      if (training.is_online) {
        typeValue = 1;
        setLocationRequired(false);
      }
      if (training.is_offline || training.location) {
        typeValue = 2;
      }
      if (training.is_online && training.is_offline) {
        typeValue = 3;
      }
      if (typeValue > 1)
        setLocationRequired(true);
      setType(typeValue)
      form.setFieldsValue({ type: typeValue });
      fetchVideos()
    }
  }, []);

  function fetchVideos() {
    getTrainingVideo(training.id).then(data => {
      setVideos(data)
    })
  }

  function hasVideosChanged(value) {
    if (typeof value == 'undefined')
      return
    setShowVideosEndRequired(value)
    if (value) {
      fetchVideos()
      form.setFieldsValue({
        show_videos_end: training.show_videos_end ? moment(training.show_videos_end) : moment().add(15, 'days')
      })
    }
  }

  function addVideo(trainingDateId, date) {
    Modal.confirm({
      icon: <PlusCircleOutlined />,
      title: <>{"Tambah Video " + date}</>,
      okText: "Simpan",
      width: 640,
      content: <>
        <Form layout="vertical" form={formVideo}>
          <Form.Item
            label="Judul"
            name="name"
            rules={[{ required: true, message: 'Masukkan judul video' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Embed"
            name="code"
            rules={[{ required: true, message: 'Masukkan Kode Embed' }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </>,
      onOk: async () => {
        const values = await formVideo.validateFields()
        const data = await saveNewTrainingVideo({ training_date_id: trainingDateId, ...values })
        if (data) {
          fetchVideos()
        }
        formVideo.setFieldsValue({ name: '', code: '', })
      },
    })
  }

  function removeVideo(videoId) {
    deleteTrainingVideo(videoId).then(data => {
      fetchVideos()
    })
  }

  return (
    <>
      <Form
        scrollToFirstError={true}
        form={form}
        layout="vertical"
        initialValues={
          !update
            ? {
              location: null,
              trainer_id: null,
              trainer_ids: [],
              time_start: moment("09:00", "HH:mm"),
              time_end: moment("17:00", "HH:mm"),
              // is_online: true,
              publicly_visible: true,
              price: 2500000,
              price_offline: 2500000,
              max_participants: 10,
              max_participants_offline: 10,
              note: "",
              notification_first: true,
              notification_full: true,
              days_before_closing: 2,
              repeat_participants_enabled: false,
              repeat_participants: 0,
              group_link: "",
              participant_notes: "",
            }
            : {
              ...training,
              time_start: moment(training.time_start, "HH:mm"),
              time_end: moment(training.time_end, "HH:mm"),
              repeat_participants_enabled: training.repeat_participants > 0,
            }
        }
        preserve
        onFinish={(v) => {
          if (!v.repeat_participants_enabled || v.repeat_participants <= 0)
            v.repeat_participants = 0
          v.is_online = type % 2 == 1;
          v.is_offline = type > 1;
          const result = {
            default_price: v.price,
          };
          const trainingOption = trainingOptions.find(
            (o) => o.id === v.training_option_id
          );
          let trainers_data = []
          let training_dates = []
          if (!update) {
            v.dates.map(date => {
              trainers_data.push(trainers.find((o) => o.id === date.trainer_id))
            })
            v.trainer_ids = []
            v.dates.map(date => {
              v.trainer_ids.push(date.trainer_id)
            })
            v.dates.map(date => {
              training_dates.push(date.date.endOf("day").toISOString())
            })
            // v.dates = _.uniq(
            //   v.dates.map((date) => date.date.endOf("day").toISOString())
            // );
          }
          if (v.has_videos == null)
            v.has_videos = false
          Modal.confirm({
            title: "Ringkasan",
            icon: null,
            style: { top: 10 },
            width: 700,
            content: (
              <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Pilihan training">
                  {trainingOption.name}
                </Descriptions.Item>
                <Descriptions.Item label="Tipe">
                  {/* {v.is_online ? "Online" : "Offline"} */}
                  {(() => {
                    switch (type) {
                      case 1: return "Online";
                      case 2: return "Offline";
                      case 3: return "Online dan Offline";
                    }
                  })()}
                </Descriptions.Item>
                {!update && (
                  <Descriptions.Item label="Tanggal dan Trainer">
                    <List>
                      {training_dates.map((date, index) => {
                        return (
                          <List.Item key={index}>
                            Hari ke-{index + 1} :{" "}
                            {moment(date).format("dddd, D MMMM yyyy")}
                            <br />
                            <Tag>{trainers_data[index].name}</Tag>
                          </List.Item>
                        );
                      })}
                    </List>
                  </Descriptions.Item>
                )}
                {type > 1 &&
                  <>
                    <Descriptions.Item label="Lokasi">
                      {v.location ? v.location : "-"}
                    </Descriptions.Item>
                  </>
                }
                <Descriptions.Item label="Ruang">
                  {v.room ? v.room : "-"}
                </Descriptions.Item>
                {/* <Descriptions.Item label="Trainer">
                  {trainers_data.map(trainer => {
                    return <Tag>{trainer.name}</Tag>
                  })}
                </Descriptions.Item> */}
                <Descriptions.Item label={"Harga" + (type == 3 ? " Online" : "")}>
                  {trainingOption.default_price > v.price && (
                    <Typography.Text delete style={{ display: "block" }}>
                      {toRupiah(trainingOption.default_price)}
                    </Typography.Text>
                  )}
                  {toRupiah(result.default_price)}
                </Descriptions.Item>
                {type == 3 &&
                  <Descriptions.Item label={"Harga Offline"}>
                    {trainingOption.default_price > v.price_offline && (
                      <Typography.Text delete style={{ display: "block" }}>
                        {toRupiah(trainingOption.default_price)}
                      </Typography.Text>
                    )}
                    {toRupiah(v.price_offline)}
                  </Descriptions.Item>
                }
                <Descriptions.Item label={"Maksimal peserta" + (type == 3 ? " Online" : "")}>
                  {v.max_participants}
                </Descriptions.Item>
                {type == 3 &&
                  <Descriptions.Item label={"Maksimal peserta Offline"}>
                    {v.max_participants_offline}
                  </Descriptions.Item>
                }
                {v.repeat_participants_enabled && (
                  <Descriptions.Item label={"Jumlah Maksimum Peserta Mengulang"}>
                    {v.repeat_participants}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Waktu">
                  {v.time_start.format("HH:mm")} - {v.time_end.format("HH:mm")}
                </Descriptions.Item>
                <Descriptions.Item label="Tampilkan di halaman jadwal untuk publik">
                  {v.publicly_visible ? "Iya" : "Tidak"}
                </Descriptions.Item>
                <Descriptions.Item label="Mengirim notifikasi jika ada pendaftar pertama">
                  {v.notification_first ? "Iya" : "Tidak"}
                </Descriptions.Item>
                <Descriptions.Item label="Mengirim notifikasi jika kelas penuh">
                  {v.notification_full ? "Iya" : "Tidak"}
                </Descriptions.Item>
                <Descriptions.Item label="Hari sebelum training ditutup">
                  {v.days_before_closing}
                </Descriptions.Item>
                <Descriptions.Item label="Catatan">
                  {v.note}
                </Descriptions.Item>
                <Descriptions.Item label="Tautan Grup Whatsapp">
                  {v.group_link}
                </Descriptions.Item>
                <Descriptions.Item label="Catatan Untuk Peserta">
                  {v.participant_notes}
                </Descriptions.Item>
                <Descriptions.Item label="Apakah memiliki rekaman kelas?">
                  {v.has_videos ? "Iya" : "Tidak"}
                </Descriptions.Item>
                {v.has_videos &&
                  <Descriptions.Item label="Waktu video selesai ditampilkan">
                    {moment(v.show_videos_end).format("dddd, D MMMM yyyy HH:mm:ss Z")}
                  </Descriptions.Item>
                }
              </Descriptions>
            ),
            okText: "Simpan",
            onOk: () =>
              onSubmit({
                ...v,
                time_start: v.time_start.format("HH:mm"),
                time_end: v.time_end.format("HH:mm"),
              }),
          });
        }}
        onValuesChange={(v) => {
          const trainingOption = trainingOptions.find(
            (o) => o.id === form.getFieldValue('training_option_id')
          );
          if (!trainingOption)
            return
          if ("training_option_id" in v) {
            form.setFieldsValue({
              price: trainingOption.default_price,
              price_offline: trainingOption.default_price,
              max_participants: trainingOption.default_max_participant,
              max_participants_offline: trainingOption.default_max_participant_offline,
            });
          }
          if ("type" in v) {
            if (v.type == 2) {
              form.setFieldsValue({ max_participants: trainingOption.default_max_participant_offline })
            } else {
              form.setFieldsValue({ max_participants: trainingOption.default_max_participant })
            }
          }
        }}
      >
        <Form.Item
          name="training_option_id"
          label="Pilihan training"
          rules={[{ required: true, message: "Mohon pilih pilihan training" }]}
        >
          {!update || (update && !trainingOptionsLoading) ? (
            <Select
              placeholder="Pilih salah satu training"
              showSearch
              optionFilterProp="label"
              loading={trainingOptionsLoading}
            >
              {trainingOptions.map((t) => (
                <Select.Option key={t.id} value={t.id} label={t.name}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <Select disabled>
              <Select.Option
                key={training.training_option.id}
                value={training.training_option.id}
              >
                {training.training_option.name}
              </Select.Option>
            </Select>
          )}
        </Form.Item>

        {showDatesField && (
          <>
            <Form.Item
              name="default_trainer_id"
              label="Default Trainer"
            >
              <Select
                placeholder="Pilih salah satu trainer"
                showSearch
                optionFilterProp="label"
                loading={trainingOptionsLoading}
                onChange={(v) => { setDefaultTrainerId(v) }}
              >
                {trainers.map((t) => (
                  <Select.Option label={t.name} key={t.id} value={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.List
              name="dates"
              rules={[
                {
                  validator: async (_, dates) => {
                    if (!dates || dates.length < 1) {
                      return Promise.reject(
                        new Error("Mohon tambahkan tanggal pelaksanaan training")
                      );
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => {
                return (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        key={field.key}
                        label={index === 0 ? "Tanggal pelaksanaan dan Trainer" : ""}
                      >
                        <Space>
                          <Form.Item
                            // {...field}
                            name={[field.name, 'date']}
                            noStyle
                            validateTrigger={["onChange", "onBlur"]}
                            rules={[
                              {
                                required: true,
                                message: "Mohon masukkan tanggal",
                              },
                            ]}
                          >
                            <DatePicker multiple format="dddd, D MMMM yyyy" />
                          </Form.Item>
                          <Form.Item
                            name={[field.name, 'trainer_id']}
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Mohon masukkan trainer",
                              },
                            ]}
                            initialValue={defaultTrainerId}
                          >
                            <Select
                              showSearch
                              placeholder="Pilih trainer"
                              optionFilterProp="label"
                              style={{
                                width: "16em"
                              }}
                            >
                              {trainers.map((t) => (
                                <Select.Option label={t.name} key={t.id} value={t.id}>
                                  {t.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Space>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            style={{ marginLeft: 10, cursor: "pointer" }}
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={() => add()}
                      >
                        Tambah tanggal pelaksanaan
                      </Button>
                      <Form.ErrorList errors={errors} />
                    </Form.Item>
                  </>
                );
              }}
            </Form.List>
          </>
        )}
        <Form.Item
          name="type"
          label="Tipe"
          rules={[
            {
              required: true,
              message: "Mohon masukkan tipe",
            },
          ]}
        >
          {/* <Radio.Group>
            <Radio.Button value={true}>Online</Radio.Button>
            <Radio.Button value={false}>Offline</Radio.Button>
          </Radio.Group> */}
          <Select
            value={type}
            // defaultValue={type}
            onChange={(value) => {
              setType(value);
              if (value == 1)
                setLocationRequired(false);
              else
                setLocationRequired(true);
            }}
          >
            <Select.Option value={3} label="semua">
              Online dan Offline
            </Select.Option>
            <Select.Option value={1} label="online">
              Online
            </Select.Option>
            <Select.Option value={2} label="offline">
              Offline
            </Select.Option>
          </Select>
        </Form.Item>
        {locationRequired &&
          <>
            <Form.Item shouldUpdate noStyle>
              <Form.Item
                name="location"
                label="Lokasi"
                rules={[{ required: locationRequired, message: "Mohon pilih lokasi" }]}
              >
                <AutoComplete
                  placeholder="Masukkan lokasi training"
                  options={locations}
                  filterOption={(inputValue, locations) =>
                    locations.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                />
              </Form.Item>
            </Form.Item>
          </>
        }
        <Form.Item label="Ruang" name="room">
          <Input placeholder="Masukkan nama ruang training" />
        </Form.Item>

        {/* <Form.Item
          name="trainer_ids"
          label="Trainer"
          rules={[{ required: true, message: "Mohon pilih trainer" }]}
        >
          <Select
            showSearch
            mode="multiple"
            optionFilterProp="label"
            placeholder="Pilih trainer"
          >
            {trainers.map((t) => (
              <Select.Option label={t.name} key={t.id} value={t.id}>
                {t.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}

        <Form.Item
          name="price"
          label={"Harga" + (type == 3 ? " Online" : "")}
          rules={[
            {
              required: true,
              message: "Mohon masukkan harga",
            },
          ]}
        >
          <Input type="number" addonBefore="Rp" />
        </Form.Item>

        {(type == 3) &&
          <Form.Item
            name="price_offline"
            label="Harga Offline"
            rules={[
              {
                required: true,
                message: "Mohon masukkan harga",
              },
            ]}
          >
            <Input type="number" addonBefore="Rp" />
          </Form.Item>
        }

        <Form.Item hidden name="default_price" label="Harga">
          <Input type="number" addonBefore="Rp" />
        </Form.Item>

        <Form.Item
          name="max_participants"
          label={"Jumlah Maksimal Peserta" + (type == 3 ? " Online" : "")}
          rules={[
            {
              required: true,
              message: "Mohon masukkan jumlah maksimal peserta",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>

        {(type == 3) &&
          <Form.Item
            name="max_participants_offline"
            label={"Jumlah Maksimal Peserta Offline"}
            rules={[
              {
                required: true,
                message: "Mohon masukkan jumlah maksimal peserta",
              },
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        }

        <Form.Item
          valuePropName="checked"
          name="repeat_participants_enabled"
          label="Batasan Maksimum Peserta Mengulang"
        >
          <Switch checkedChildren="Ada" unCheckedChildren="Tidak Ada"
            onChange={(checked) => {
              if (!checked)
                return
              if (form.getFieldValue('repeat_participants') <= 0)
                form.setFieldsValue({ repeat_participants: 2 })
            }}
          />
        </Form.Item>

        <Form.Item shouldUpdate noStyle>
          {() => form.getFieldValue('repeat_participants_enabled') && (
            <Form.Item
              name="repeat_participants"
              label="Jumlah Maksimum Peserta Mengulang"
              rules={[
                {
                  required: true,
                  message: "Mohon masukkan jumlah peserta",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          )}
        </Form.Item>

        <div style={{ display: showAdvancedFields ? "block" : "none" }}>
          <Form.Item
            label="Waktu mulai"
            name="time_start"
            rules={[
              {
                required: true,
                message: "Mohon masukkan waktu selesai training",
              },
            ]}
          >
            <TimePicker format="HH:mm" />
          </Form.Item>
          <Form.Item
            label="Waktu selesai"
            name="time_end"
            rules={[
              {
                required: true,
                message: "Mohon masukkan waktu selesai training",
              },
            ]}
          >
            <TimePicker format="HH:mm" />
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            name="publicly_visible"
            label="Tampilkan di halaman jadwal untuk publik"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            name="notification_first"
            label="Mengirim notifikasi jika ada pendaftar pertama"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            name="notification_full"
            label="Mengirim notifikasi jika kelas penuh"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            name="days_before_closing"
            label="Hari sebelum training ditutup"
            rules={[
              {
                required: true,
                message: "Mohon masukkan jumlah hari",
              },
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        </div>

        <Form.Item>
          <a
            // href={() => false}
            onClick={() => setShowAdvancedFields(!showAdvancedFields)}
          >
            {showAdvancedFields ? <UpOutlined /> : <DownOutlined />} Tampilkan
            lebih {showAdvancedFields ? "sedikit" : "banyak"}
          </a>
        </Form.Item>
        <Form.Item name="note" label="Catatan">
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          name="group_link"
          label="Tautan Grup Whatsapp"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="participant_notes"
          label="Catatan Untuk Peserta"
        >
          <Input.TextArea />
        </Form.Item>
        {update && (
          <>
            <Form.Item
              name="has_videos"
              label="Apakah memiliki rekaman kelas?"
              valuePropName="checked"
            >
              <Switch checkedChildren="Ya" unCheckedChildren="Tidak" onChange={hasVideosChanged} />
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => form.getFieldValue('has_videos') && (
                <Form.Item
                  name="show_videos_end"
                  label="Waktu video selesai ditampilkan"
                  valuePropName={'datetime'}
                  rules={[{ required: showVideosEndRequired, message: 'Masukkan Waktu video selesai ditampilkan' }]}
                >
                  <DatePicker
                    showTime
                    format="dddd, D MMMM yyyy HH:mm:ss Z"
                    defaultValue={training.show_videos_end ? moment(training.show_videos_end) : moment().add(15, 'days')}
                  />
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => form.getFieldValue('has_videos') && (<>
                <Collapse activeKey={training.dates.map((item) => item.id)}>
                  {training.dates.map((item, day) => (
                    <Panel
                      showArrow={false}
                      header={"Hari ke-" + (day + 1) + " " + moment(item.date, "YYYY-MM-DDT").format("dddd, D MMMM YYYY")}
                      key={item.id}
                      extra={
                        <Button
                          size="small"
                          type="primary"
                          icon={<PlusCircleOutlined />}
                          onClick={() => addVideo(item.id, "Hari ke-" + (day + 1) + " " + moment(item.date, "YYYY-MM-DDT").format("dddd, D MMMM YYYY"))}>
                          Tambah
                        </Button>
                      }
                    >
                      {videos.filter((video) => video.training_date_id == item.id).map((video) => (
                        <Card
                          style={{ width: '40em' }}
                          cover={
                            <div dangerouslySetInnerHTML={{ __html: video.code }}></div>
                          }
                          actions={[
                            <Popconfirm
                              title="Hapus Video"
                              description="Apakah anda yakin akan menghapus video ini?"
                              onConfirm={() => {
                                removeVideo(video.id)
                              }}
                              onCancel={() => { }}
                              okText="Ya"
                              cancelText="Tidak"
                            >
                              <Button danger icon={<MinusCircleOutlined />}>Hapus</Button>
                            </Popconfirm>
                          ]}
                        >
                          <Meta title={<center>{video.name}</center>} />
                        </Card>
                      ))}
                    </Panel>
                  ))}
                </Collapse>
              </>)}
            </Form.Item>
            <br />
          </>
        )}
        <Form.Item shouldUpdate noStyle>
          {() => (
            <center>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                loading={submitLoading}
                icon={<ArrowRightOutlined />}
              >
                Lanjutkan
              </Button>
            </center>
          )}
        </Form.Item>
      </Form>
    </>
  );
}